import './index.less';
import { isJoJoUp } from '@/const';
import { addClass } from '@/utils/dom';
var timer = null;
var content = null;

var Toast = function () {
  function Toast() {
    this.body = document.body;
  }

  Toast.prototype.getTemplate = function () {
    return (
      /* html */
      "<div class=\"open-miniApp-toast-content\">\n      <div class='open-miniApp-tip'>\n        <div class=".concat(isJoJoUp ? 'jojoup-logo' : 'jojo-logo', "></div>\n        <div class='loading-dot'></div>\n        <div class='wechat-img'></div>\n      </div>\n      <div class=\"open-miniApp-text\">\u5373\u5C06\u524D\u5F80\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\u5B8C\u6210\u9886\u53D6\u5662~</div>\n  </div>\n  ")
    );
  };

  Toast.prototype.factory = function (ops, fn) {
    var _this = this;

    this.hide();
    content = document.createElement('div');
    addClass(content, 'open-miniApp-toast');
    content.innerHTML = this.getTemplate();
    this.body.appendChild(content);
    timer = setTimeout(function () {
      if (typeof fn === 'function') {
        fn();
      }

      _this.hide();

      timer = null;
    }, ops.delay < 20 ? ops.delay * 1000 : ops.delay);
  };

  Toast.prototype.show = function (delay, fn) {
    if (delay === void 0) {
      delay = 3000;
    }

    this.factory({
      delay: delay
    }, fn);
  };

  Toast.prototype.hide = function () {
    if (content) {
      clearTimeout(timer);
      this.body.removeChild(content);
      content = null;
    }
  };

  return Toast;
}();

export default new Toast();